import axios from '@/libs/api.request'
// 关键词搜索
export const setSeacher = (params) => {
    return axios.request({
        url: `/keysearch/create`,
        method: 'post',
        data: params
    })
}
export const getSukerList = (params) => {
    return axios.request({
        url: `/product`,
        method: 'post',
        data: params
    })
}
export const setPurchaseNum = (params) => { // 记录立即购买/类别选择--人数次数 (离心机的记录/移液器的记录)
    return axios.request({
        url: `/action/create`,
        method: 'post',
        data: params
    })
}
